<template>
  <div class="e-product e-product--date">
    <div class="e-product__image">
      <img :src="require(`@/assets/images/${date.img}`)" :alt="date.name">
    </div>
    <!-- / e-product__image -->

    <div class="e-product__bottom">
      <input class="e-product__checkbox" type="radio" @change="updateDate()" name="date" :checked="date.name == selectedDate">
      <div class="e-product__checked"></div>
      <p class="e-product__name">{{ date.name }}</p>
    </div>
    <!-- / e-product__bottom -->

  </div>
  <!-- / e-product -->

</template>

<script>
export default {
  name: "Date",
  props: {
    date: {
      type: Object
    }
  },
  components: {
  },
  data() {
    return {
      
    }
  },
  methods: {
    updateDate() {
      this.$store.commit('updateDate', { date: this.date.name });
    }
  },
  computed: {
    selectedDate() {
      return this.$store.state.selectedDate;
    }
  },
  watch: {
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/e-product.scss';
</style>

